import { type ISliderBlockTypeOneSlideModel } from '../../../../internal/models/SliderBlockTypeOneSlideModel';
import { type ISliderBlockTypeOneModel } from '../ISliderBlockTypeOneModel';

/**
 * @description Модель слайдера типа один. Слайдер представляет собой виджет, который содержит в себе список слайдов и чипы для выбора набора слайдов.
 * Сам слайд содержит в себе изображение снизу, заголовок и описание сверху.
 * @param chipsOption - Опция чипа.
 * @param slides - Слайды.
 * @example
 * const sliderBlockTypeOneModel = new SliderBlockTypeOneModel(new ChipsOption('Первый набор слайдов', 'first'), [
 *   new SliderBlockTypeOneSlideModel('Первый слайд', 'Первое описание', 'imageUrlOne'),
 *   new SliderBlockTypeOneSlideModel('Второй слайд', 'Второе описание', 'imageUrlTwo'),
 * ]);
 * const chipsOption = sliderBlockTypeOneModel.chipsOption;
 * const slides = sliderBlockTypeOneModel.slides;
 */
export class SliderBlockTypeOneModel implements ISliderBlockTypeOneModel {
  public readonly chipsOption: ISliderBlockTypeOneModel['chipsOption'];
  public readonly slides: ISliderBlockTypeOneSlideModel[];

  public constructor(chipsOption: ISliderBlockTypeOneModel['chipsOption'], slides: ISliderBlockTypeOneSlideModel[]) {
    this.chipsOption = chipsOption;
    this.slides = slides;
  }
}
